import axios from "axios";
import qs from "qs";
// axios 配置
axios.defaults.timeout = 300000;
// axios.defaults.headers['Content-Type'] = 'application/json; charset=UTF-8';
// // axios.defaults.headers.post['X-Requested-With'] = 'XMLHttpRequest';
let baseURL = "https://map.iyunzhushou.com/wpmapsysws/services/";
// baseURL = "http://192.168.199.151:8120/wpmapsysws/services/";
axios.defaults.baseURL = baseURL;
//返回状态判断
axios.interceptors.response.use(
	function (response) {
		return response;
	},
	function (error) {
		return Promise.reject(error);
	}
);

export function fetch(url, params) {
	return new Promise((resolve, reject) => {
		axios.post(url, params).then(response => {
				if (response.status == 200) {
					resolve(response.data);
				}
			},
			err => {
				reject(err);
				console.log(err);
			}
		).catch(error => {
			reject(error);
		});
	});
}

export function fetchImage(url, params, config) {
	return new Promise((resolve, reject) => {
		axios.post(url, params, config).then(response => {
				if (response.status == 200) {
					resolve(response.data);
				}
			},
			err => {
				reject(err);
				console.log(err);
			}
		).catch(error => {
			reject(error);
		});
	});
}

axios.defaults.withCredentials = true
// create an axios instance
const request = axios.create({
	baseURL,
	timeout: 5000,
})
//请求
request.interceptors.request.use(
	config => {
		// config.headers['Content-Type'] = 'application/json;charset=UTF-8';
		// config.headers['Access-Control-Allow-Origin'] = '*';
		return config
	},
	error => {
		return Promise.reject(error)
	}
)
//响应
request.interceptors.response.use(res => {
	if (res.status === 200) {
		if (res.data.code === 0) {
			return res.data.data;
		} else {
			console.log(res.data, 'err223')
			return Promise.reject(res.data)
		}
	}
}, error => {
	console.log('err' + error)// for debug
	return Promise.reject(error)
})
let uploadPath = baseURL + 'admin/putObject', wxImage = baseURL + 'admin/imageUpload',
	postcardPutObject = baseURL + 'admin/postcardPutObject';
export {request, uploadPath, wxImage, postcardPutObject}
export default {
	postRequest(params) {
		var reg = new RegExp("null", "g");
		var regParams = params.jsonParam.replace(reg, "");
		var methodParams = qs.parse(regParams);
		return fetch(params.methodUrl, methodParams);
	},
	postImageRequest(url, params, config) {
		return fetchImage(url, params, config);
	}
};



// WEBPACK FOOTER //
// ./src/axios/index.js